import React from "react";
import { Modal, Typography, Divider, Spin, Empty } from "antd";

import PrimaryButton from "../Forms/PrimaryButton";
import { downloadFile, getOrderLongestDispatchTime } from "../../utils";
import {
  DYED_TYPES,
  estimatedDispatchTimes,
  orderStatus,
} from "../../constant";

const { Title, Text } = Typography;

export default function DispatchHistory({
  open,
  onClose,
  title = "Dispatch History",
  loading,
  orderData,
}) {
  const dispatch_history = orderData?.dispatch_history || [];
  const order_items_not_dispatched =
    orderData?.items?.filter(
      (item) => item.status !== orderStatus.dispatched,
    ) || [];

  return (
    <Modal
      className="form-css custom-modal my-5"
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={500}
    >
      <Title level={2} className="font-abhaya mb-3">
        {title}
      </Title>

      {/* ✅ Loading state */}
      {orderData.status === orderStatus.cancelled ||
      orderData.status === orderStatus.parts_cancelled ? (
        <div className="rounded-2xl border border-[#D9D9D9] p-3 flex flex-col justify-between mb-3">
          {/* Header */}
          <div className="pt-2">
            <div className="flex justify-between items-start gap-4">
              <div className="flex flex-col">
                <p className="text-base text-left leading-normal">
                  <strong>Part Cancelled:</strong>
                </p>
                {orderData.cancel_date}
              </div>

              <div className="flex flex-col text-right">
                <p className="text-base leading-normal">
                  <strong>Cancelled by:</strong>
                </p>
                <p
                  className="text-base leading-normal truncate max-w-[200px]"
                  title={`Cancelled by: ${orderData?.update_by_user?.full_name}`}
                >
                  {orderData?.update_by_user?.full_name}
                </p>
              </div>
            </div>
          </div>

          <Divider className="my-3" />

          <div className="flex gap-3 items-center">
            <div className="w-[50px] h-[50px] bg-[#A334341A] rounded-full flex items-center justify-center">
              <img
                src="/assets/icons/User.png"
                alt="User"
                className="w-auto h-[30px] object-contain"
              />
            </div>

            <div className="flex flex-col text-start">
              <span className="text-gray-500">
                <strong>Remark:</strong>
              </span>
              <span className="text-start">{orderData?.cancel_remark}</span>
            </div>
          </div>
        </div>
      ) : orderData.status === orderStatus.parts_dispatched ? (
        <div className="rounded-2xl border border-[#D9D9D9] p-3 flex flex-col justify-between mb-3">
          <div className="flex items-center justify-start gap-3">
            {/* Truck icon inside background circle */}
            <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
              <img
                src="/assets/icons/TruckTrailer.png"
                alt="Truck"
                className="w-4 h-4 object-contain"
              />
            </div>
            <div className="flex flex-col items-start">
              <Text className="text-left text-black">
                <strong>Estimated Dispatch</strong> -{" "}
                {getOrderLongestDispatchTime(order_items_not_dispatched)}
              </Text>
            </div>
          </div>
        </div>
      ) : null}
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Spin size="large" />
        </div>
      ) : dispatch_history.length === 0 ? (
        /* ✅ Empty state */
        <Empty description="No dispatch history found" />
      ) : (
        dispatch_history.map((item, index) => (
          <div
            key={index}
            className="text-black rounded-2xl border border-[#D9D9D9] p-3 flex flex-col justify-between mb-3"
          >
            {/* Header */}
            <div className="pt-2">
              <div className="flex justify-between items-start gap-4">
                <div className="flex flex-col">
                  <p className="text-base text-left leading-normal">
                    <strong>Dispatched On: </strong>
                  </p>
                  {item.dispatch_history_date}
                </div>

                <div className="flex flex-col text-right">
                  <p className="text-base leading-normal">
                    <strong>Updated by: </strong>
                  </p>
                  <p
                    className="text-base leading-normal truncate max-w-[200px]"
                    title={`Updated by: ${item.dispatch_history_updated_by}`}
                  >
                    {item.dispatch_history_updated_by}
                  </p>
                </div>
              </div>
            </div>

            <Divider className="my-3" />

            {/* Actions */}
            <div className="flex justify-center items-center">
              <PrimaryButton
                text="Bill / Invoice"
                icon={
                  <img
                    src="/assets/icons/Article.png"
                    alt="Article"
                    className="w-auto h-[20px] object-contain"
                  />
                }
                onClick={() =>
                  downloadFile(
                    item?.dispatch_history_invoice_url,
                    `invoice_${orderData?.order_id}.pdf`,
                  )
                }
                iconOnleft
                btnType="ghost"
                disabled={loading}
              />

              <Divider type="vertical" className="mx-6 h-12" />

              <PrimaryButton
                text="Transport Details"
                icon={
                  <img
                    src="/assets/icons/MapPinSimpleArea.png"
                    alt="MapPin"
                    className="w-auto h-[20px] object-contain"
                  />
                }
                onClick={() =>
                  downloadFile(
                    item?.dispatch_history_transport_details_url,
                    `transport_${orderData?.order_id}.pdf`,
                  )
                }
                iconOnleft
                btnType="ghost"
                disabled={loading}
              />
            </div>
          </div>
        ))
      )}
    </Modal>
  );
}
